import type { Attachment } from '@certhon/models';
import { MessageSquare, Paperclip, MapPin } from 'lucide-react';

interface AnnotationIndicatorsProps {
  attachments: Attachment[];
}

/**
 * Small inline icons indicating the presence of notes, file attachments,
 * or geotags on a value field. Clicking navigates to the detail drill-down
 * (handled by the parent wrapper).
 */
export function AnnotationIndicators({
  attachments,
}: AnnotationIndicatorsProps) {
  if (!attachments || attachments.length === 0) return null;

  const hasNotes = attachments.some((a) => a.type === 'note');
  const hasFiles = attachments.some((a) => a.type === 'attachment');
  const hasGeotags = attachments.some((a) => a.type === 'geotag');

  if (!hasNotes && !hasFiles && !hasGeotags) return null;

  return (
    <div className="text-muted-foreground flex items-center gap-1">
      {hasNotes && <MessageSquare className="h-3 w-3" />}
      {hasFiles && <Paperclip className="h-3 w-3" />}
      {hasGeotags && <MapPin className="h-3 w-3" />}
    </div>
  );
}
